import { useEffect, useState, type CSSProperties, type FC } from 'react'
import ReactEcharts from 'echarts-for-react'
import cx from 'classnames'
import { twMerge } from 'tailwind-merge'
import { type DefaultProps } from '../common'
import { createChartOptions } from './create-options'

interface RangeGraphProps extends DefaultProps {
  value: number
  style?: CSSProperties | undefined
}

export const RangeGraphV2: FC<RangeGraphProps> = ({
  // Common default properties for each component
  className,
  id,
  testId,
  ariaLabel,
  value,
  style,
}) => {
  const limitedValue = Math.max(0, Math.min(value, 24))

  const startGradient = Math.max(limitedValue - 1.6, 0)
  const endGradient = Math.min(limitedValue + 1.6, 24)

  const startOffset = startGradient / 24
  const valueOffset = limitedValue / 24
  const endOffset = endGradient / 24

  const [width, setWidth] = useState(window.innerWidth)

  const handleWindowSizeChange = (): void => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange)

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange)
    }
  }, [])

  const isDesktop = width > 1024

  // Component base class names. Can be overriden by className property.
  const baseClass = cx('w-full relative w-full h-auto')

  // Final class names
  const finalClasses = twMerge(baseClass, className)

  return (
    <div
      className={finalClasses}
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      aria-hidden="true"
    >
      <p className="absolute ml-2 top-1/4 typo-primary-sm-semibold text-[#018DF8]">RETURN</p>
      <ReactEcharts style={style} option={createChartOptions({ startOffset, valueOffset, endOffset, isDesktop })} />
      <p className="absolute ml-2 bottom-1/4 typo-primary-sm-semibold text-[#FE5552] -mb-3">RISK</p>
    </div>
  )
}
